// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const HIDE_ERROR = "HIDE_ERROR";
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';


export const USER_TOKEN_SET = 'user_token_set';

// technician visits module const
export const GET_VISITS = 'GET_VISITS';
export const GET_VISITS_SUCCESS = 'GET_VISITS_SUCCESS';
export const SHOW_VISITS_MESSAGE = 'SHOW_VISITS_MESSAGE';
export const ON_SHOW_VISITS_LOADER = 'ON_SHOW_VISITS_LOADER';
export const ON_HIDE_VISITS_LOADER = 'ON_HIDE_VISITS_LOADER';

// update visit 

export const UPDATE_NEW_VISIT = 'UPDATE_NEW_VISIT'
export const UPDATE_NEW_VISIT_SUCCESS = 'UPDATE_NEW_VISIT_SUCCESS';
// technician macros module const
export const GET_MACROS = 'GET_MACROS';
export const GET_MACROS_SUCCESS = 'GET_MACROS_SUCCESS';
export const SHOW_MACROS_MESSAGE = 'SHOW_MACROS_MESSAGE';
export const ADD_UPDATE_MACRO = 'ADD_UPDATE_MACRO';
export const ADD_UPDATE_MACRO_SUCCESS = 'ADD_UPDATE_MACRO_SUCCESS';

// public macros module const
export const GET_ALL_PUBLIC_MACROS = 'GET_ALL_PUBLIC_MACROS';
export const GET_ALL_PUBLIC_MACROS_SUCCESS = 'GET_ALL_PUBLIC_MACROS_SUCCESS';
export const GET_ALL_PUBLIC_MACROS_ERROR = 'GET_ALL_PUBLIC_MACROS_ERROR';

//categorized public macros module const
export const GET_ALL_CATEGORIZED_PUBLIC_MACROS = 'GET_ALL_CATEGORIZED_PUBLIC_MACROS';
export const GET_ALL_CATEGORIZED_PUBLIC_MACROS_SUCCESS = 'GET_ALL_CATEGORIZED_PUBLIC_MACROS_SUCCESS';
export const GET_ALL_CATEGORIZED_PUBLIC_MACROS_ERROR = 'GET_ALL_CATEGORIZED_PUBLIC_MACROS_ERROR';

// technician sites module const
export const GET_SITES = 'GET_SITES';
export const GET_SITES_SUCCESS = 'GET_SITES_SUCCESS';
export const SHOW_SITES_MESSAGE = 'SHOW_SITES_MESSAGE';
export const ADD_UPDATE_SITE = 'ADD_UPDATE_SITE'

// technician patient visits module const
export const GET_PATIENT_VISITS = 'GET_PATIENT_VISITS';
export const GET_PATIENT_VISITS_SUCCESS = 'GET_PATIENT_VISITS_SUCCESS';
export const SHOW_PATIENT_VISITS_MESSAGE = 'SHOW_PATIENT_VISITS_MESSAGE';
export const ON_SHOW_PATIENT_VISITS_LOADER = 'ON_SHOW_PATIENT_VISITS_LOADER';
export const ON_HIDE_PATIENT_VISITS_LOADER = 'ON_HIDE_PATIENT_VISITS_LOADER';
export const HIDE_PATIENT_MESSAGE = "HIDE_PATIENT_MESSAGE";
export const GET_PATIENT_VISITS_BY_SEARCH = 'GET_PATIENT_VISITS_BY_SEARCH';
export const GET_PATIENT_VISITS_BY_SEARCH_SUCCESS = 'GET_PATIENT_VISITS_BY_SEARCH_SUCCESS';
export const GET_PATIENT_VISITS_BY_SEARCH_START = 'GET_PATIENT_VISITS_BY_SEARCH_START';
export const GET_PATIENT_VISITS_BY_SEARCH_ERROR = 'GET_PATIENT_VISITS_BY_SEARCH_ERROR';
export const RESET_PATIENT_VISITS = 'RESET_PATIENT_VISITS';
export const GET_PATIENT_PRIOR_REPORTS = 'GET_PATIENT_PRIOR_REPORTS';
export const GET_PATIENT_PRIOR_VISITS = 'GET_PATIENT_PRIOR_VISITS';

// technician new visits module const
export const GET_NEW_VISITS = 'GET_NEW_VISITS';
export const GET_NEW_VISITS_SUCCESS = 'GET_NEW_VISITS_SUCCESS';
export const SHOW_NEW_VISITS_MESSAGE = 'SHOW_NEW_VISITS_MESSAGE';
export const ON_SHOW_NEW_VISITS_LOADER = 'ON_SHOW_NEW_VISITS_LOADER';
export const ON_HIDE_NEW_VISITS_LOADER = 'ON_HIDE_NEW_VISITS_LOADER';
export const ON_HIDE_NEW_VISIT_MESSAGE = 'ON_HIDE_NEW_VISIT_MESSAGE';

export const ON_ADD_UPDATE_NEW_VISITS_LOADER = 'ON_ADD_UPDATE_NEW_VISITS_LOADER';
export const ON_HIDE_ADD_UPDATE_NEW_VISITS_LOADER = 'ON_HIDE_ADD_UPDATE_NEW_VISITS_LOADER';
export const ON_HIDE_ADD_UPDATE_NEW_VISIT_MESSAGE = 'ON_HIDE_ADD_UPDATE_NEW_VISIT_MESSAGE';
export const UNDO_VISIT_START = 'UNDO_VISIT_START';
export const UNDO_VISIT_START_SUCCESS = 'UNDO_VISIT_START_SUCCESS';
export const SHOW_UNDO_NEW_VISIT_START_MESSAGE = 'SHOW_UNDO_NEW_VISIT_START_MESSAGE';

// technician modality types module const
export const GET_MODALITY_TYPES = 'GET_MODALITY_TYPES';
export const GET_MODALITY_TYPES_SUCCESS = 'GET_MODALITY_TYPES_SUCCESS';

// worklist filter
export const SET_WORKLIST_FILTER = 'SET_WORKLIST_FILTER';

// Admin sites module const
export const GET_VISITS_REPORT = 'GET_VISITS_REPORT';
export const GET_VISITS_REPORT_START = 'GET_VISITS_REPORT_START';
export const GET_VISITS_REPORT_SUCCESS = 'GET_VISITS_REPORT_SUCCESS';
export const GET_VISITS_REPORT_ERROR = 'GET_VISITS_REPORT_ERROR';
export const GET_VISITS_REPORT_RELOAD = 'GET_VISITS_REPORT_RELOAD';

export const UNLOCK_TECH_VISIT = "UNLOCK_TECH_VISIT";
export const UNLOCK_TECH_VISIT_SUCCESS = "UNLOCK_TECH_VISIT_SUCCESS";
export const UNLOCK_TECH_VISIT_ERROR = "UNLOCK_TECH_VISIT_ERROR";
export const UNLOCK_TECH_VISIT_START = "UNLOCK_TECH_VISIT_START";
export const UNLOCK_SUBMITTED_TECH_VISIT_SUCCESS = "UNLOCK_SUBMITTED_TECH_VISIT_SUCCESS";


